import contentServiceClient from "./client"
import { Response } from "../Model"

interface TrustBannerResponse {
    bottomImage: string,
    topImage: string,
    topBannerUrl: string,
    bottomBannerUrl: string
}

const getTrustBanner = () => {
    return contentServiceClient.get<Response<TrustBannerResponse>>(
        `trust-banner`,
    )
}

export { getTrustBanner}
